/** @deprecated This fn is wrong. */
export const memoize = <T>(factory: () => T, ds?: any[]) => {
	let cache: T | undefined = undefined;
	let pds: any[] | undefined = undefined;

	if (!pds || !ds || ds.some((d, i) => d !== pds![i])) {
		pds = ds;
		cache = factory();
	}

	return cache as T;
};
